import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { useSEO, useSchema } from '../../utils/seo';

export default function Reviews() {
  useSEO({
    title: 'App Reviews - Getestete Earning-Apps mit Auszahlungsbeweisen | EarnProof',
    description: 'Ehrliche Reviews von Mistplay, Freecash und Scrambly mit echten Einnahmen-Nachweisen. Alle Apps persönlich getestet mit Screenshots und Auszahlungsbeweisen.',
    keywords: 'app reviews, mistplay review, freecash erfahrungen, scrambly test, earning apps bewertung, auszahlungsbeweise',
    canonical: 'https://example.com/reviews',
  });

  useSchema({
    type: 'ItemList',
    data: {
      name: 'Getestete Earning Apps',
      description: 'Ehrliche Reviews von Gaming und Earning Apps',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'Review',
            itemReviewed: {
              '@type': 'SoftwareApplication',
              name: 'Mistplay',
              applicationCategory: 'GameApplication',
              operatingSystem: 'Android',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: 4.2,
              bestRating: 5,
            },
            author: {
              '@type': 'Person',
              name: 'Christopher Humpert',
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'Review',
            itemReviewed: {
              '@type': 'SoftwareApplication',
              name: 'Freecash',
              applicationCategory: 'GameApplication',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: 4.5,
              bestRating: 5,
            },
            author: {
              '@type': 'Person',
              name: 'Christopher Humpert',
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'Review',
            itemReviewed: {
              '@type': 'SoftwareApplication',
              name: 'Scrambly',
              applicationCategory: 'GameApplication',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: 3.8,
              bestRating: 5,
            },
            author: {
              '@type': 'Person',
              name: 'Christopher Humpert',
            },
          },
        },
      ],
    },
  });

  const [selectedApp, setSelectedApp] = useState(null);
  const [activeCategory, setActiveCategory] = useState('Alle');

  const categories = [
    { name: 'Alle', count: 3 },
    { name: 'Gaming', count: 3 },
    { name: 'Passive Income', count: 0 }
  ];

  const apps = [
    {
      name: 'Mistplay',
      category: 'Gaming',
      rating: 4.2,
      earnings: '42.810 Punkte (ca. 150 EUR)',
      timeframe: '3 Monate',
      status: 'verified',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/56d57ce807cb1122274c17420296d8cc.webp',
      pros: ['Große Auswahl an Spielen', 'Schnelle Punktesammlung', 'Zuverlässige Auszahlungen', 'Einfache Bedienung'],
      cons: ['Begrenzte Spiele-Auswahl in Deutschland', 'Punkte verfallen nach Inaktivität'],
      description: 'Mistplay belohnt dich fürs Spielen von Mobile Games. Sammle Punkte durch das Spielen verschiedener Android-Spiele und tausche sie gegen Geschenkgutscheine ein.',
      link: 'https://mistplay.onelink.me/ZGRQ/yk2ojuvu',
      detailedReview: {
        setup: 'Die Anmeldung bei Mistplay ist sehr einfach. Nach dem Download aus dem Google Play Store registrierst du dich mit deiner E-Mail-Adresse. Die Verifizierung dauert nur wenige Minuten.',
        earnings: 'Ich habe 42.810 Punkte (ca. 150 EUR) gesammelt, hauptsächlich durch das Spielen von Puzzle- und Strategiespielen. Die Punkte werden basierend auf deiner Ingame-Zeit automatisch gutgeschrieben - je länger du spielst, desto mehr Punkte sammelst du. Neue Spiele geben am Anfang besonders viele Punkte.',
        payout: 'Auszahlungen erfolgen über Google Play Guthaben oder Amazon Gutscheine. Mindestbetrag sind 5€. Ich nutze meistens Google Play Gutscheine, da ich diese strategisch auf anderen Apps einsetze, um dort höhere Levels zu erreichen und noch mehr zu verdienen. Meine erste Auszahlung kam nach 2 Tagen.',
        tips: 'Spiele täglich mindestens 30 Minuten für Bonus-Punkte. Neue Spiele geben mehr Punkte als bereits gespielte.',
        verdict: 'Mistplay ist perfekt für Gelegenheitsspieler. Zuverlässig und einfach zu nutzen, aber die Verdienstmöglichkeiten sind begrenzt.'
      }
    },
    {
      name: 'Freecash',
      category: 'Gaming',
      rating: 4.5,
      earnings: '950€',
      timeframe: '4 Monate',
      status: 'verified',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/8037cb8c2994e886ae0edd5e6f0f83e3.png',
      pros: ['Vielfältige Verdienstmöglichkeiten', 'Gaming und Tasks kombiniert', 'Niedrige Auszahlungsgrenze', 'Schnelle Bearbeitung', 'Neues Cashback-System'],
      cons: ['Manche Angebote zeitaufwendig', 'Nicht alle Spiele verfügbar in DE', 'Account-Verifizierung erforderlich'],
      description: 'Freecash kombiniert Gaming mit anderen Verdienstmöglichkeiten. Spiele Spiele und erledige Tasks um Geld zu verdienen. Sehr vielseitige Plattform mit neuem Cashback-System.',
      link: '',
      detailedReview: {
        setup: 'Registrierung über Website oder App. Verifizierung mit Ausweis erforderlich, aber der Prozess ist schnell und unkompliziert.',
        earnings: '950€ durch Mix aus Gaming (90%) und Tasks (10%). Höchste Einnahmen durch Mobile Game Downloads.',
        payout: 'PayPal, Krypto oder Geschenkgutscheine ab 5€. Auszahlung klappt problemlos, meistens innerhalb einer Stunde.',
        tips: 'Kombiniere verschiedene Aktivitäten für maximale Einnahmen. Täglich einloggen für Bonus-Coins. High-Value Offers prüfen. Das neue Cashback-System ausprobieren.',
        verdict: 'Beste Plattform für ernsthafte Verdiener. Vielfältig, zuverlässig und mit den höchsten Verdienstmöglichkeiten.'
      }
    },
    {
      name: 'Scrambly',
      category: 'Gaming',
      rating: 3.8,
      earnings: '210$',
      timeframe: '2 Monate',
      status: 'verified',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/bb03acf15eefb177a3ce4c4af635014b.jpeg',
      pros: ['Ähnlich wie Freecash', 'Verschiedene Spiele und Tasks', 'Faire Belohnungen', 'Regelmäßige Angebote'],
      cons: ['Support reagiert langsam (bis 7 Tage)', 'Probleme bei höheren Gewinnen', 'Weniger Angebote als Freecash'],
      description: 'Scrambly ist eine Alternative zu Freecash. Verdiene Geld durch Mobile Games und verschiedene Tasks. Ähnliches Konzept, aber mit eigenen Angeboten.',
      link: '',
      detailedReview: {
        setup: 'Einfache Anmeldung über Website oder App. Ähnlicher Prozess wie bei Freecash. Verifizierung kann erforderlich sein.',
        earnings: '210$ durch Gaming und Tasks. Die Plattform funktioniert ähnlich wie Freecash, hat aber teilweise andere Spiele und Angebote.',
        payout: 'PayPal oder Geschenkgutscheine ab 5€. Auszahlungen funktionieren im Normalfall gut, aber bei höheren Beträgen kann es zu Verzögerungen kommen. Der Support braucht manchmal bis zu 7 Tage für eine Antwort.',
        tips: 'Nutze Scrambly parallel zu Freecash für zusätzliche Verdienstmöglichkeiten. Prüfe regelmäßig neue Angebote. Bei Problemen früh den Support kontaktieren.',
        verdict: 'Solide Alternative zu Freecash mit ähnlichem Konzept. Gut als Ergänzung, aber der langsame Support und gelegentliche Probleme bei höheren Auszahlungen sind negativ.'
      }
    }
  ];

  const filteredApps = activeCategory === 'Alle' 
    ? apps 
    : apps.filter(app => app.category === activeCategory);

  const openModal = (app) => {
    setSelectedApp(app);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedApp(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="min-h-screen bg-gray-950">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900/20 to-cyan-900/20"></div>
        <div className="relative max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            App Reviews
            <span className="block text-2xl md:text-3xl text-teal-400 font-normal mt-2">
              Ehrliche Tests mit echten Einnahmen
            </span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Alle Apps wurden von mir persönlich getestet. Mit Screenshots, Auszahlungsbeweisen und ehrlichen Pros &amp; Cons.
          </p>
        </div>
      </section>

      {/* Filter Categories */}
      <section className="py-8 px-4 sm:px-6 lg:px-8 border-b border-gray-800">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => setActiveCategory(category.name)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeCategory === category.name
                    ? 'bg-teal-400 text-gray-900'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Apps Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredApps.map((app, index) => (
              <div key={index} className="bg-gray-900/50 border border-gray-700 rounded-xl overflow-hidden hover:border-teal-700/50 transition-all duration-300 hover:transform hover:scale-105">
                <div className="relative">
                  <img 
                    src={app.image} 
                    alt={`${app.name} App Interface`}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-4 right-4">
                    <div className="bg-teal-400 text-gray-900 px-2 py-1 rounded-full text-xs font-bold flex items-center space-x-1">
                      <i className="ri-verified-badge-fill"></i>
                      <span>VERIFIED</span>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-xl font-bold text-white">{app.name}</h3>
                    <div className="flex items-center space-x-1">
                      <i className="ri-star-fill text-yellow-400"></i>
                      <span className="text-white font-semibold">{app.rating}</span>
                    </div>
                  </div>
                  
                  <p className="text-teal-400 text-sm font-medium mb-3">{app.category}</p>
                  
                  <div className="bg-gray-800/50 rounded-lg p-3 mb-4">
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="text-2xl font-bold text-teal-400">{app.earnings}</div>
                      </div>
                      <div className="w-12 h-12 flex items-center justify-center bg-teal-900/30 rounded-lg">
                        <i className="ri-money-euro-circle-line text-xl text-teal-400"></i>
                      </div>
                    </div>
                  </div>
                  
                  <p className="text-gray-300 text-sm mb-4">{app.description}</p>
                  
                  <div className="space-y-3 mb-4">
                    <div>
                      <div className="text-green-400 text-xs font-semibold mb-1">PROS:</div>
                      <ul className="text-xs text-gray-300 space-y-1">
                        {app.pros.map((pro, i) => (
                          <li key={i}>• {pro}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <div className="text-red-400 text-xs font-semibold mb-1">CONS:</div>
                      <ul className="text-xs text-gray-300 space-y-1">
                        {app.cons.map((con, i) => (
                          <li key={i}>• {con}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <Button 
                      variant="primary" 
                      size="sm" 
                      className="w-full"
                      onClick={() => openModal(app)}
                    >
                      Vollständigen Review lesen
                    </Button>
                    
                    {app.name === 'Freecash' && (
                      <a 
                        href="https://freecash.com/r/NIM8I"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full"
                      >
                        <Button 
                          variant="outline" 
                          size="sm" 
                          className="w-full"
                        >
                          Jetzt Freecash ausprobieren
                        </Button>
                      </a>
                    )}
                    
                    {app.name === 'Scrambly' && (
                      <a 
                        href="https://go.scrambly.io/YbltcZ"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full"
                      >
                        <Button 
                          variant="outline" 
                          size="sm" 
                          className="w-full"
                        >
                          Jetzt Scrambly ausprobieren
                        </Button>
                      </a>
                    )}
                    
                    {app.link && (
                      <a 
                        href={app.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full"
                      >
                        <Button 
                          variant="outline" 
                          size="sm" 
                          className="w-full"
                        >
                          Jetzt {app.name} ausprobieren
                        </Button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedApp && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gray-900 border border-gray-700 rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-gray-900 border-b border-gray-700 p-6 flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <img 
                  src={selectedApp.image} 
                  alt={selectedApp.name}
                  className="w-16 h-16 rounded-lg object-cover"
                />
                <div>
                  <h2 className="text-2xl font-bold text-white">{selectedApp.name}</h2>
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center space-x-1">
                      <i className="ri-star-fill text-yellow-400"></i>
                      <span className="text-white font-semibold">{selectedApp.rating}</span>
                    </div>
                    <span className="text-teal-400 font-medium">{selectedApp.earnings}</span>
                  </div>
                </div>
              </div>
              <button 
                onClick={closeModal}
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors"
              >
                <i className="ri-close-line text-xl text-gray-300"></i>
              </button>
            </div>
            
            <div className="p-6 space-y-8">
              {/* Setup */}
              <div>
                <h3 className="text-xl font-bold text-white mb-3 flex items-center">
                  <i className="ri-settings-3-line text-teal-400 mr-2"></i>
                  Anmeldung & Setup
                </h3>
                <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.setup}</p>
              </div>

              {/* Earnings */}
              <div>
                <h3 className="text-xl font-bold text-white mb-3 flex items-center">
                  <i className="ri-money-euro-circle-line text-teal-400 mr-2"></i>
                  Meine Einnahmen
                </h3>
                <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.earnings}</p>
              </div>

              {/* Payout */}
              <div>
                <h3 className="text-xl font-bold text-white mb-3 flex items-center">
                  <i className="ri-bank-card-line text-teal-400 mr-2"></i>
                  Auszahlung
                </h3>
                <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.payout}</p>
              </div>

              {/* Tips */}
              <div>
                <h3 className="text-xl font-bold text-white mb-3 flex items-center">
                  <i className="ri-lightbulb-line text-teal-400 mr-2"></i>
                  Tipps & Tricks
                </h3>
                <p className="text-gray-300 leading-relaxed">{selectedApp.detailedReview.tips}</p>
              </div>

              {/* Pros & Cons */}
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-green-900/20 border border-green-700/30 rounded-lg p-4">
                  <h4 className="text-green-400 font-bold mb-3 flex items-center">
                    <i className="ri-thumb-up-line mr-2"></i>
                    Vorteile
                  </h4>
                  <ul className="space-y-2">
                    {selectedApp.pros.map((pro, i) => (
                      <li key={i} className="text-gray-300 flex items-start">
                        <i className="ri-check-line text-green-400 mr-2 mt-0.5 flex-shrink-0"></i>
                        {pro}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="bg-red-900/20 border border-red-700/30 rounded-lg p-4">
                  <h4 className="text-red-400 font-bold mb-3 flex items-center">
                    <i className="ri-thumb-down-line mr-2"></i>
                    Nachteile
                  </h4>
                  <ul className="space-y-2">
                    {selectedApp.cons.map((con, i) => (
                      <li key={i} className="text-gray-300 flex items-start">
                        <i className="ri-close-line text-red-400 mr-2 mt-0.5 flex-shrink-0"></i>
                        {con}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Verdict */}
              <div className="bg-teal-900/20 border border-teal-700/30 rounded-lg p-6">
                <h3 className="text-xl font-bold text-white mb-3 flex items-center">
                  <i className="ri-award-line text-teal-400 mr-2"></i>
                  Mein Fazit
                </h3>
                <p className="text-gray-300 leading-relaxed text-lg">{selectedApp.detailedReview.verdict}</p>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-3">
                {selectedApp.name === 'Mistplay' && selectedApp.link && (
                  <a 
                    href={selectedApp.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full"
                  >
                    <Button 
                      variant="primary" 
                      className="w-full"
                    >
                      <i className="ri-external-link-line mr-2"></i>
                      Jetzt Mistplay ausprobieren
                    </Button>
                  </a>
                )}
                
                {selectedApp.name === 'Freecash' && (
                  <a 
                    href="https://freecash.com/r/NIM8I"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full"
                  >
                    <Button 
                      variant="primary" 
                      className="w-full"
                    >
                      <i className="ri-external-link-line mr-2"></i>
                      Jetzt Freecash ausprobieren
                    </Button>
                  </a>
                )}
                
                {selectedApp.name === 'Scrambly' && (
                  <a 
                    href="https://go.scrambly.io/YbltcZ"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full"
                  >
                    <Button 
                      variant="primary" 
                      className="w-full"
                    >
                      <i className="ri-external-link-line mr-2"></i>
                      Jetzt Scrambly ausprobieren
                    </Button>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

